import React from "react";
import { AlertCard } from "@truevault/aquilo";
import { CategoryDto } from "../../../common/service/server/dto/datamap/DataMapDto";

// From POL-7431; this is not the same as the sensitive PIC list. Keep in sync with the constants in
//  EmailService.kt and update both files together.
const SECURITY_CONCERN_PIC_KEYS: readonly string[] = [
  "ssn",
  "driver-license-number",
  "california-id-number",
  "passport-number",
  "tax-id-number",
  "military-id-number",
  "financial-account-number",
  "health-insurance-id",
  "financial-account-creds",
];
const SECURITY_CONCERN_PIC_GROUP_KEYS: readonly string[] = ["biometric-info"];

export const SensitiveInfoCallout = ({ collectedPICs }: { collectedPICs?: CategoryDto[] }) => {
  const securityConcernPICs = collectedPICs
    ?.filter(
      (pic) =>
        SECURITY_CONCERN_PIC_KEYS.includes(pic.key ?? "") ||
        SECURITY_CONCERN_PIC_GROUP_KEYS.includes(pic.picGroupKey ?? ""),
    )
    .map((pic) => pic.name);

  if (!securityConcernPICs?.length) return null;

  return (
    <div className="tw-boundary">
      <AlertCard variant="warning" containerClasses="mb-0">
        <div className="text-t3">
          <strong>Don't disclose sensitive information.</strong>
          <div className="mt-2">Here&apos;s what you collect:</div>
          <ul className="mt-1 mb-0 list-disc pl-5">
            {securityConcernPICs.map((pic) => (
              <li key={pic}>{pic}</li>
            ))}
          </ul>
        </div>
      </AlertCard>
    </div>
  );
};
